import { render, staticRenderFns } from "./DriverLicenseReader.vue?vue&type=template&id=aa1449e6&scoped=true&"
import script from "./DriverLicenseReader.vue?vue&type=script&lang=js&"
export * from "./DriverLicenseReader.vue?vue&type=script&lang=js&"
import style0 from "./DriverLicenseReader.vue?vue&type=style&index=0&id=aa1449e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1449e6",
  null
  
)

export default component.exports